import Repository from '@/repositories/marketing'
const resource = 'analytics/erfm_reports'

export default {
  getErfmInsights(payload,config){
    return Repository.get(`${resource}/erfm_insights.json?`,payload, config)
  },
  getGroupAliases (config) {
    return Repository.get(`${resource}/group_aliases.json`, config)
  },
  saveGroupAliases (payload, config) {
    return Repository.post(`${resource}/group_aliases.json`, payload, config)
  },
  getEngagementAliases(config){
    return Repository.get(`${resource}/engagement_groups.json`, config)
  },
  fetchERFMSettings(config){
    return Repository.get(`${resource}/rfm_settings.json`, config)
  },
  saveERFMSettings(payload,config){
    return Repository.post(`${resource}/rfm_settings.json`, payload, config)
  },
}


